import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Checkbox from "@material-ui/core/Checkbox";
import { getDistrictSchools as getDistrictSchoolsAction } from "../../../store/actions/generic";
import Input from "../../../components/ui/input/input";
import Button from "@material-ui/core/Button";
import {
  GET_USER_BY_ID,
  UPDATE_USER_BY_ID,
  DELETE_USER,
  actionTypeSuccess,
  SIGN_IN,
} from "../../../store/actionTypes";
import { schoolCities } from "../../../common/constants";
import {
  getAllowedClassIds,
  isClassAllowedForSchool,
  isSchoolSelectable,
  CLASS_MISMATCH_MESSAGE,
  NO_CLASS_FOR_SCHOOL_MESSAGE,
} from "../../../common/schoolClasses";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {
  updateUserById,
  getSchoolCoaches,
  deleteUser,
  createAPaidReceipt,
  cancelAPaidReceipt,
} from "../../../store/actions/generic";
import Modal from "@material-ui/core/Modal";
import MaterialBackDrop from "../../../components/ui/loading/materialBackDrop";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "../../../components/ui/typography";
import { actionCreate } from "../../../store/actions/actionCreator";
import { setAuthHeadersToLocalStorage } from "../../../helpers/localStorageHelper";
import { Grid } from "@material-ui/core";
import { EXAM_SEASONS } from "../../../common/examData";
import sha256 from "crypto-js/sha256";
import Hex from "crypto-js/enc-hex";
import { teamExamLink } from "../components/generateLinks";

// import { competitorList, verdict, verdictNames } from "../../../common/ilFinaliData_11";

import {
  isPhoneValid,
  PHONE_MASK_REGEX,
  PHONE_FORMAT_HINT,
  PHONE_MASK,
  PHONE_MASK_FORMAT_CHARS,
} from "../../../common/phone";

const UpdateUser =({ onClose, selectedUser }) => {
  const authenticatedUser = useSelector(
    (state) => state.auth && state.auth.user,
  );
  //const selectedUser = user; //useSelector((state) => state.generic.selectedUser);

  const reloadDistrictSchools = (city, district) => {
    dispatch(getDistrictSchoolsAction(city, district));
  };

  const loadingUserUpdate = useSelector(
    (state) => state.loading[UPDATE_USER_BY_ID],
  );

  const loadingSelectedUser = useSelector(
    (state) => state.loading[GET_USER_BY_ID],
  );

  const loadingDeleteUser = useSelector((state) => state.loading[DELETE_USER]);

  const dispatch = useDispatch();
  const districtSchools = useSelector((state) => state.generic.districtSchools);

  const [params, setParams] = useState({
    selectedUserId: selectedUser.id,
    selectedUserName: selectedUser.name,
    selectedUserEmail: selectedUser.email,
    selectedUserPhone: selectedUser.phone || "",
    selectedUserDistrict: selectedUser.district,
    selectedUserCity: selectedUser.city,
    selectedUserSchoolId: selectedUser.school_id,
    selectedUserRole: selectedUser.role,
    selectedUserClass: selectedUser.class_id,
    classCoaches: {},
    newPass: "",
  });

  // Eski kayıtlarda telefon farklı biçimde olabiliyor ("05321234567" gibi). Değeri bozmamak için
  // maskeyi sadece numara kayıt formu biçimindeyse (ya da boşsa) açıyoruz; kişi alanı silince
  // maske devreye girer ve numarayı yeniden yazar.
  const [phoneMaskOn, setPhoneMaskOn] = useState(
    !selectedUser.phone || PHONE_MASK_REGEX.test(selectedUser.phone),
  );

  const setParam = (key, value) => {
    let newVal = value;
    if (key === "selectedUserEmail") {
      newVal = value.toLocaleLowerCase("tr-TR");
    }

    setParams({
      ...params,
      [key]: newVal,
    });
  };

  // const setParam = ({ target: { name, value } }) => {
  //   let newVal = value;
  //   if(name ==="name" || name ==="surname") newVal= value.toLocaleUpperCase();
  //   else if(name ==="email" || name ==="email_2") newVal= value.toLocaleLowerCase();
  //   setParam(name, newVal)};

  useEffect(() => {
    reloadDistrictSchools(selectedUser.city, selectedUser.district);
  }, []);

  useEffect(() => {
    const fillClassCoaches = (coachesFromDb) => {
      let tempCoachClasses = {};
      for (const coach of coachesFromDb || []) {
        const { id, class_id, name } = coach;

        tempCoachClasses[class_id] = {
          coachName: name,
          coachId: id,
        };
      }
      setParams((prev) => ({ ...prev, classCoaches: tempCoachClasses }));
    };

    if (selectedUser.role !== 1) {
      fillClassCoaches(selectedUser.all_coaches_of_this_school);
      return;
    }
    if (params.selectedUserSchoolId === selectedUser.school_id)
      fillClassCoaches(selectedUser.all_coaches_of_this_school);
    if (!params.selectedUserSchoolId) return;

    // Kullanıcı bilgisi oturum açıldığı andan kalma olabilir ya da okul bu ekranda değiştirilmiş olabilir.
    // Seçili okulun güncel öğretmen listesini sunucudan çekiyoruz ki başka öğretmenin sınıfları gri görünsün.
    let isCurrent = true;
    getSchoolCoaches(params.selectedUserSchoolId).then((coaches) => {
      if (isCurrent && coaches) fillClassCoaches(coaches);
    });
    return () => {
      isCurrent = false;
    };
    // Sadece okul değişince yeniden dolduruyoruz. Kullanıcı bilgisi arka planda yenilendiğinde
    // (App.js) ekrandaki kaydedilmemiş sınıf seçimleri silinmesin.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.selectedUserSchoolId]);

  if (!selectedUser) return null;
  if (loadingSelectedUser || loadingUserUpdate) return <MaterialBackDrop />;

  const deleteUserButton = authenticatedUser.role === 2 &&
    selectedUser.paid_receipts.length === 0 && ( // ücret ödeyenleri sistemden kolayca silebilmek hoş olmaz.
      <div
        style={{
          display: "flex",
          fontSize: "1.5rem",
          justifyContent: "space-between",
        }}
      >
        {" "}
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            if (
              window.confirm(
                selectedUser.name +
                  "  kişisine ait tüm verileri sistemden silmek istediğinize emin misiniz?",
              ) &&
              window.confirm("Derin bi nefes al bi daha düşün... Emin misin?")
            ) {
              dispatch(deleteUser(selectedUser.id)).then((res) => {
                if (res) {
                  alert(res.message);
                  onClose();
                } else alert("HATA: Kişi Silinemedi.");
              });
            }
          }}
        >
          SİSTEMDEN SİL
        </Button>
      </div>
    );

  const emailInput = (
    <div style={{ width: "100%", maxWidth: 400 }}>
      <Input
        style={{ fontSize: 16 }}
        height={40}
        labelColor="black"
        label="Email"
        name="selectedUserEmail"
        onChange={({ target: { name, value } }) => setParam(name, value)}
        value={params.selectedUserEmail}
      />
    </div>
  );

  // Okul listesi henüz yüklenmediyse kullanıcının mevcut okul adını kullan
  const getSchoolName = (schoolId) => {
    const school = districtSchools.find((s) => s.id === schoolId);
    if (school) return school.name;
    if (schoolId === selectedUser.school_id) return selectedUser.school_name;
    return "";
  };
  const selectedSchoolName = getSchoolName(params.selectedUserSchoolId);

  // Öğretmene sadece okulunun kademesindeki sınıfları gösteriyoruz.
  // Kademe dışında kalmış eski seçimleri kaydederken siliyoruz.
  const coachClassOptions = getAllowedClassIds(selectedSchoolName);

  const classChangerStudent = selectedUser.role === 0 && (
    <div style={{ width: 150 }}>
      <Typography color={"black"} font="tadao" size="smaller" weight="normal">
        Sınıf{" "}
      </Typography>
      <Select
        labelId="demo-simple-select-helper-label"
        id="demo-simple-select-helper"
        value={params.selectedUserClass}
        onChange={(e) => {
          setParam("selectedUserClass", e.target.value);
        }}
      >
        {getAllowedClassIds(selectedSchoolName).map((c) => (
          <MenuItem value={c}>
            {c === 9 ? "Hazırlık / 9. Sınıf" : c + ". Sınıf"}{" "}
          </MenuItem>
        ))}
      </Select>
    </div>
  );

  const classChangerCoach = selectedUser.role === 1 && (
    <div>
      <Typography color={"black"} font="tadao" size="smaller" weight="normal">
        Sınıf{" "}
      </Typography>
      <div>
        <Grid container rowSpacing={3}>
          {coachClassOptions.map((s) => {
            let nameOfTheCoach = "";
            let idOfTheCoach = "";

            const coachData = params.classCoaches[s];
            if (coachData) {
              nameOfTheCoach = " (" + coachData.coachName + ")";
              idOfTheCoach = coachData.coachId;
            }

            // Başka öğretmenin sınıfı kimse tarafından (admin dahil) seçilemez; önce o öğretmenden kaldırılmalı.
            const isThisBoxDisabled =
              idOfTheCoach &&
              idOfTheCoach !== selectedUser.id;

            if (isThisBoxDisabled)
              nameOfTheCoach = " (Öğretmen: " + coachData.coachName + ")";

            return (
              <Grid
                xs={3}
                item
                key={"class_checker_" + s}
                style={isThisBoxDisabled ? { color: "#9e9e9e" } : undefined}
              >
                <Checkbox
                  checked={!!coachData}
                  value={params.selectedUserClass}
                  disabled={!!isThisBoxDisabled}
                  onChange={() => {
                    if (isThisBoxDisabled) return; // başka öğretmenin sınıfı seçilemez
                    let tempCoachClasses = { ...params.classCoaches };
                    if (coachData) delete tempCoachClasses[s];
                    // datayı ekle
                    else {
                      tempCoachClasses[s] = {
                        coachName: selectedUser.name,
                        coachId: selectedUser.id,
                      };
                    }
                    setParam("classCoaches", tempCoachClasses);
                  }}
                />
                {s === 9
                  ? "Hazırlık / 9. Sınıf" + nameOfTheCoach
                  : s + ". Sınıf" + nameOfTheCoach}
              </Grid>
            );
          })}
        </Grid>
      </div>
      {(
        <div
          style={{
            marginTop: 15,
            padding: "10px 12px",
            maxWidth: 700,
            fontSize: 14,
            lineHeight: 1.5,
            color: "#5f4b00",
            background: "#fff8e1",
            border: "1px solid #ffe082",
            borderRadius: 6,
          }}
        >
          <b>Bilgilendirme:</b> Gri görünen sınıflar okulunuzda başka bir
          öğretmen tarafından seçilmiştir ve sizin tarafınızdan seçilemez. Bu
          sınıf bu sene size geçecekse, önceden kayıtlı olan öğretmenin kendi
          profil sayfasına giriş yaparak bu sınıfı kendi seçimlerinden
          kaldırması gerekmektedir. Öğretmene ulaşamıyorsanız{" "}
          <a href="mailto:info@tzv.org.tr">info@tzv.org.tr</a> adresine e-posta
          gönderebilirsiniz.
          <br />
          
        </div>
      )}
    </div>
  );

  const braiquireCouponCode = selectedUser.brain_quire_coupon_code &&
    authenticatedUser.role === 2 && (
      <div style={{ marginTop: 15 }}>
        {"Griceviz kupon kodu:  " +
          selectedUser.brain_quire_coupon_code.coupon_code}
      </div>
    );

  const roleChanger = authenticatedUser.role === 2 && (
    <div
      style={{
        // marginTop: "30px",
        // marginBottom: "30px",
        fontSize: "1.1rem",
      }}
    >
      <Checkbox
        checked={params.selectedUserRole == 0}
        onChange={(e) => {
          setParam("selectedUserRole", e.target.checked ? 0 : 1);
        }}
        name="selectedUserRoleCheck"
        style={{
          color: "black",
          padding: 0,
          marginRight: "10px",
        }}
      />
      {"Öğrenci"}
      <Checkbox
        checked={params.selectedUserRole == 1}
        onChange={(e) => {
          setParam("selectedUserRole", e.target.checked ? 1 : 0);
        }}
        name="selectedUserRoleCheck"
        style={{
          color: "black",
          padding: 0,
          marginLeft: "50px",
          marginRight: "10px",
        }}
      />
      {"Öğretmen"}
    </div>
  );

  const paymentStatusChanger = authenticatedUser.role === 2 &&
    selectedUser.role === 0 &&
    selectedUser.paid_receipts.length === 0 && (
      <div>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            if (
              window.confirm(
                "Bu kişinin ücret durumu 'ödendi' olarak değişsin mi?",
              ) &&
              window.confirm("İyice düşünüp taşındın mı?")
            ) {
              const product_id = 20; // TODO: Bu çok amele oldu, başka bir çözüm düşünmek gerek.
              dispatch(createAPaidReceipt(selectedUser.id, product_id)).then(
                (res) => {
                  if (res) {
                    alert(res.message);
                  } else
                    alert("HATA: Bişeyler ters gitti... Keşke düz gitseydi...");
                },
              );
            }
          }}
        >
          'Ödendi' Yap
        </Button>
      </div>
    );

  const paymentCanceler = authenticatedUser.role === 2 &&
    selectedUser.role === 0 &&
    selectedUser.paid_receipts.length === 1 && (
      <div>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            if (window.confirm("Bu kişinin ödemesi iptal edilsin mi?")) {
              const product_id = 20; // TODO: Bu çok amele oldu, başka bir çözüm düşünmek gerek.
              dispatch(cancelAPaidReceipt(selectedUser.id, product_id)).then(
                (res) => {
                  if (res) {
                    alert(res.message);
                  } else
                    alert("HATA: Bişeyler ters gitti... Keşke düz gitseydi...");
                },
              );
            }
          }}
        >
          Ödemeyi İptal Et
        </Button>
      </div>
    );

  const passwordRenewer = authenticatedUser.role === 2 && (
    <div style={{ width: "180px" }}>
      <Input
        labelColor="black"
        label="Yeni Şifre"
        name="newPass"
        onChange={({ target: { name, value } }) => setParam(name, value)}
        value={params.newPass}
      />
    </div>
  );

  const nameSurnameInput = (
    <div style={{ width: "100%", maxWidth: 400 }}>
      <Input
        style={{ fontSize: 16 }}
        labelColor="black"
        label="Adı-Soyadı"
        name="selectedUserName"
        onChange={({ target: { name, value } }) => setParam(name, value)}
        value={params.selectedUserName}
      />
    </div>
  );

  const phoneInput = (
    <div style={{ width: "100%", maxWidth: 400 }}>
      <Input
        style={{ fontSize: 16 }}
        labelColor="black"
        label="Telefon"
        name="selectedUserPhone"
        placeholder="(5xx)-xxx-xx-xx"
        onChange={({ target: { name, value } }) => {
          if (!phoneMaskOn && value.trim() === "") setPhoneMaskOn(true);
          setParam(name, value);
        }}
        value={params.selectedUserPhone}
        mask={phoneMaskOn ? PHONE_MASK : undefined}
        formatChars={PHONE_MASK_FORMAT_CHARS}
        maxLength={phoneMaskOn ? undefined : 15}
        warning={
          phoneMaskOn || isPhoneValid(params.selectedUserPhone)
            ? ` (Örnek: ${PHONE_FORMAT_HINT})`
            : " Numaranız geçerli değil. Lütfen silip yeniden yazınız."
        }
      />
    </div>
  );

  const schoolChooser = (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      <div style={{ marginRight: "15px", width: "300px" }}>
        <Input
          defaultValue={{
            value: params.selectedUserCity,
            title: params.selectedUserCity,
          }}
          labelColor="black"
          name="selectedUserCity"
          label="Okul İli"
          select
          value={params.selectedUserCity}
          onChange={(e, newItem) => {
            setParams({
              ...params,
              selectedUserDistrict: "",
              selectedUserCity: newItem ? newItem.value : "",
              selectedUserSchoolId: "",
            });
          }}
          options={Object.keys(schoolCities)
            .sort((a, b) => a.localeCompare(b))
            .map((cityName) => {
              return { value: cityName, title: cityName };
            })}
        />
      </div>
      <div style={{ marginRight: "15px", width: "300px" }}>
        <Input
          defaultValue={{
            value: params.selectedUserDistrict,
            title: params.selectedUserDistrict,
          }}
          labelColor="black"
          name="selectedUserDistrict"
          label="Okul İlçesi"
          select
          value={params.selectedUserDistrict}
          onChange={(e, newItem) => {
            setParams({
              ...params,
              selectedUserDistrict: newItem ? newItem.value : "",
              selectedUserSchoolId: "",
            });
            const district = newItem ? newItem.value : "";
            reloadDistrictSchools(params.selectedUserCity, district);
          }}
          options={
            schoolCities[params.selectedUserCity] &&
            schoolCities[params.selectedUserCity]
              .sort((a, b) => {
                return a.localeCompare(b);
              })
              .map((districtName) => {
                return { value: districtName, title: districtName };
              })
          }
        />
      </div>
      <div style={{ flex: 1, width: "100%", maxWidth: 400 }}>
        <Input
          defaultValue={{
            value: params.selectedUserSchoolId,
            title: selectedUser.school_name,
          }}
          labelColor="black"
          name="selectedUserSchoolId"
          label="Okul"
          select
          value={params.selectedUserSchoolId}
          onChange={(e, newItem) => {
            const newSchoolId = newItem ? newItem.value : "";
            setParams({
              ...params,
              selectedUserSchoolId: newSchoolId,
              classCoaches: {},
              // Seçili sınıf yeni okulda yoksa sınıf seçimini sıfırla
              selectedUserClass:
                selectedUser.role === 0 &&
                params.selectedUserClass &&
                !isClassAllowedForSchool(
                  params.selectedUserClass,
                  getSchoolName(newSchoolId),
                )
                  ? ""
                  : params.selectedUserClass,
            });
          }}
          options={districtSchools
            .filter((s) => isSchoolSelectable(s.name))
            .map((s) => ({ value: s.id, title: s.name }))}
        />
      </div>
    </div>
  );

  const generatePersonalExamLink = ({ usr, buttonName, season, size }) => {
    // TODO: merge this with manage.js
    const { class_id, id, name, role } = usr;
    if (role !== 0 || !class_id) return null;

    let [examId, examQuestionsId] = EXAM_SEASONS[season].exam_ids[class_id];

    const id_hash = sha256(id.toString() + "tuz").toString(Hex);
    const user_identifier = id + id_hash;

    const regex_symbols = /[-!$%^&*()_+|~=`{}\[\]:\/;<>?,.@#'"]/gi;
    let userNameForUrl = name.trim().replaceAll(regex_symbols, ""); // Özel karakterleri silelim, url'de hata çıkmasına sebep olur.
    userNameForUrl = userNameForUrl.replaceAll(" ", "+");

    const link =
      "https://sinav.tzv.org.tr/linkedExam/" +
      examId +
      "&" +
      examQuestionsId +
      "&" +
      user_identifier +
      "&" +
      userNameForUrl;

    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        <Button style={{ backgroundColor: "green" }}>
          {buttonName ?? "İl Finalleri Sınavı"}
        </Button>
      </a>
    );
  };

  const teamId = selectedUser?.exam_results?.find(
    (er) => er.season === "2026_tb"
  )?.team_id;
  const İfButton =
    teamId &&
    teamExamLink({
      usr: selectedUser,
      season: "if_2526",
      buttonName: "İl Finalleri Sınavı Linki",
      teamId: teamId,
    });

  // const tbsButton = generatePersonalExamLink({
  //   usr: selectedUser,
  //   buttonName: "Takım Belirleme Sınavı Linki",
  //   season: "tb_2526",
  // });

  const saveCancelButtons = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        paddingTop: "60px",
      }}
    >
      <Button variant="contained" color="primary" onClick={onClose}>
        ÇIK
      </Button>

      <Button
        variant="contained"
        color="secondary"
        onClick={() => {
          const email = params.selectedUserEmail.trim();
          const name = params.selectedUserName.trim();
          const phone = params.selectedUserPhone.trim();

          if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email))
            alert("Lütfen geçerli bir e-posta adresi yazınız.");
          else if (name.length < 3)
            alert("Lütfen ad-soyad bilgisini eksiksiz giriniz.");
          else if (!isPhoneValid(phone))
            alert(
              `Telefon numaranız geçerli değil. Lütfen telefon alanını silip numaranızı ${PHONE_FORMAT_HINT} biçiminde yeniden yazınız.`,
            );
          else if (
            [0, 1].includes(selectedUser.role) &&
            getAllowedClassIds(selectedSchoolName).length === 0
          )
            alert(NO_CLASS_FOR_SCHOOL_MESSAGE);
          else if (
            selectedUser.role === 0 &&
            !isClassAllowedForSchool(
              params.selectedUserClass,
              selectedSchoolName,
            )
          )
            alert(CLASS_MISMATCH_MESSAGE);
          else {
            // let class_coaches = [];
            let classCoaches = params.classCoaches;
            for (const key of Object.keys(classCoaches)) {
              if (classCoaches[key].user_id === selectedUser.id) {
                classCoaches.push(key);
              }
            }

            // Öğretmenin okul kademesine uymayan eski sınıf seçimlerini gönderilen listeden çıkarıyoruz, backend bunları siler.
            if (selectedUser.role === 1) {
              classCoaches = { ...classCoaches };
              for (const classId of Object.keys(classCoaches)) {
                if (
                  classCoaches[classId].coachId === selectedUser.id &&
                  !isClassAllowedForSchool(classId, selectedSchoolName)
                )
                  delete classCoaches[classId];
              }
            }

            // let class_coaches= [];
            // for (const class_key of Object.keys(classCoaches)) {
            //   if(classCoaches[class_key].coachId === selectedUser.id){
            //     class_coaches.push(class_key)
            //   }
            // }

            dispatch(
              updateUserById({
                user_id: params.selectedUserId,
                school_id: params.selectedUserSchoolId,
                name,
                email,
                phone,
                role: Number(params.selectedUserRole),
                class_id: params.selectedUserClass,
                new_pass: params.newPass.trim(),
                updater_role: Number(authenticatedUser.role), // bazen normal kişilere update etmeyi kapatcaz, ama admine açık kalacak. Bu durumlarda lazım.
                class_coaches: classCoaches,
              }),
            ).then((res) => {
              if (res) {
                if (res.deny_message) alert(res.deny_message);
                else {
                  let updatedUser = res;

                  if (authenticatedUser.id === selectedUser.id) {
                    setAuthHeadersToLocalStorage({
                      user: JSON.stringify(updatedUser),
                    });
                    dispatch(
                      actionCreate(actionTypeSuccess(SIGN_IN), {
                        user: updatedUser,
                      }),
                    );
                  }

                  alert("Bilgileriniz başarıyla güncellendi.");
                }

                onClose({ refetchFilteredUsers: true });
              } else alert("HATA: Kayıt başarısız.");
            });
          }
        }}
      >
        KAYDET
      </Button>
    </div>
  );

  return (
    <Modal
      style={{ padding: "20px", overflow: "auto" }}
      open={true}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div
        style={{
          backgroundColor: "white",
          width: "100%",
          padding: "calc(3px + 1vw)",
          paddingTop: 30,
          paddingBottom: 30,
        }}
      >
        {authenticatedUser.role === 2 && (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {roleChanger}
            {passwordRenewer}
            {deleteUserButton}
            {paymentStatusChanger}
            {paymentCanceler}
          </div>
        )}

        {/* {selectedUser.role === 0 && authenticatedUser.role === 2 && İfButton} */}
        {emailInput}
        {nameSurnameInput}
        {phoneInput}
        {schoolChooser}
        {selectedUser.role === 0 && classChangerStudent}
        {selectedUser.role === 1 && classChangerCoach}
        {/* {selectedUser.brain_quire_coupon_code && braiquireCouponCode} */}
        {saveCancelButtons}
      </div>
    </Modal>
  );
};

export default UpdateUser;
